import { render } from "./layouts-header.vue?vue&type=template&id=62ae5075&scoped=true"
import script from "./layouts-header.vue?vue&type=script&lang=js"
export * from "./layouts-header.vue?vue&type=script&lang=js"

import "./layouts-header.vue?vue&type=style&index=0&id=62ae5075&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62ae5075"]])

export default __exports__